export const registerIntroForceRegisterSelection: boolean = true;
